import {
  Input,
  Output,
  Component,
  ViewChild,
  forwardRef,
  TemplateRef,
  HostBinding,
  EventEmitter,
  HostListener,
  ViewContainerRef,
  ViewEncapsulation,
  ElementRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
export interface Indicator {
  activate?: any;
  deactivate?: any;
  release?: any;
  finish?: any;
}

@Component({
  selector: 'PullToRefresh, nzm-pull-to-refresh',
  templateUrl: './pull-to-refresh.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PullToRefreshComponent),
      multi: true
    }
  ]
})
export class PullToRefreshComponent implements ControlValueAccessor {
  transtionCls: any = {};
  style: object = {
    '-webkit-transform': 'translate3d( 0, 0, 0 )',
    transform: 'translate3d( 0, 0, 0 )'
  };
  startY: number;
  state: any = {
    currentState: 'deactivate',
    drag: false
  };

  private _headerIndicator: Indicator = {
    activate: 'æ¾å¼ç«å³å·æ°',
    deactivate: 'ä¸æå¯ä»¥å·æ°',
    release: 'å·æ°ä¸­ããã',
    finish: 'å®æå·æ°'
  };

  private _footerIndicator: Indicator = {
    activate: 'æ¾å¼ç«å³å·æ°',
    deactivate: 'ä¸æå¯ä»¥å·æ°',
    release: 'å·æ°ä¸­ããã',
    finish: 'å®æå·æ°'
  };

  private _startTime = 0;
  private _endTime = 0;
  private _endRreach = false;
  private _direction: string = '';
  private _clientHeight: number = 0;
  private _currentContentHeight: number = 0;
  private _lastcontentOffset: number = 0;
  private _ngModelOnChange: (value: object) => {};
  private _ngModelOnTouched: () => {};

  @ViewChild('pullToRefresh', { read: ViewContainerRef })
  private _pullToRefresh: ViewContainerRef;

  @Input()
  distanceToRefresh: number = 25; //è§¦åå·æ°è·ç¦»
  @Input()
  damping: number = 100; // ä¸æçæå¤§è·ç¦»
  @Input()
  endReachedRefresh: boolean = false;
  @Input()
  refreshing: boolean = false;
  @Input()
  get direction(): string {
    return this._direction;
  }
  set direction(value: string) {
    this._direction = value;
    this.refreshUp = this._direction === 'up' || this._direction === '';
    this.refreshDown = this._direction === 'down' || this._direction === '';
  }
  @Input()
  get headerIndicator(): Indicator {
    return this._headerIndicator;
  }
  set headerIndicator(value: Indicator) {
    Object.assign(this._headerIndicator, value);
  }
  @Input()
  get footerIndicator(): Indicator {
    return this._footerIndicator;
  }
  set footerIndicator(value: Indicator) {
    Object.assign(this._footerIndicator, value);
  }
  @Output()
  onRefresh: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.am-pull-to-refresh')
  refresh: boolean = true;
  @HostBinding('class.super-container')
  container: boolean = true;
  @HostBinding('class.am-pull-to-refresh-up')
  refreshUp: boolean = false;
  @HostBinding('class.am-pull-to-refresh-down')
  refreshDown: boolean = true;

  @HostListener('touchstart', ['$event'])
  touchstart(e) {
    this._startTime = Date.now();
    if (this._direction === 'down' || (this._direction === '' && !this._endRreach)) {
      if (this.ele.nativeElement.scrollTop > 0) {
        this.startY = undefined;
        return;
      }
      this.startY = e && e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientY;
      this.state.drag = undefined;
    } else {
      this.startY = e && e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientY;
      this._clientHeight = this._pullToRefresh.element.nativeElement.clientHeight;
      this._currentContentHeight = document.getElementsByTagName('pulltorefresh')[0].clientHeight;
    }
    this.transtionCls = '';
  }
  @HostListener('touchmove', ['$event'])
  touchmove(e) {
    if (this._direction === 'down' || (this._direction === '' && !this._endRreach)) {
      if (this.ele.nativeElement.scrollTop > 0) {
        return;
      }
      let distanceY = e.changedTouches[0].clientY - this.startY;
      if (distanceY < 0) {
        // æ»å¨
        this.state.drag = false;
      } else {
        // ä¸æ
        this.state.drag = true;
      }
      if (this.state.drag) {
        // ç¦æ­¢æ»å¨
        if (e.cancelable) {
          e.preventDefault();
        }
      } else {
        return;
      }
      if (distanceY > this.damping) {
        //å½è¶è¿è®¾å®éå¼æ¯ï¼ç¼æ¢å¢å 
        distanceY = (distanceY / (distanceY + this.damping)) * this.damping * 2;
      } else if (distanceY < 0) {
        distanceY = 0;
      }
      if (distanceY > this.distanceToRefresh) {
        this.state.currentState = 'activate';
        if (this._ngModelOnChange) {
          this._ngModelOnChange(this.state);
        }
      }
      this.style = {
        '-webkit-transform': 'translate3d( 0, ' + distanceY + 'px, 0 )',
        transform: 'translate3d( 0, ' + distanceY + 'px, 0 )'
      };
    } else {
      let distanceY = e.changedTouches[0].clientY - this.startY;
      //åä¸æå¨çæ¶åï¼å¦æå½åçªå£åå®¹æ²¡ææ»å°æåï¼åä¸å®ç°æå¨çå¨ä½ï¼åä¸æ»å¨ä¸å®ç°æå¨å¨ä½
      if (
        Math.abs(this._lastcontentOffset) <= this._clientHeight - this._currentContentHeight - this.distanceToRefresh ||
        distanceY > 0
      ) {
        // æ»å¨
        this.state.drag = false;
      } else {
        // ä¸æ
        this.state.drag = true;
      }
      if (this.state.drag) {
        // ç¦æ­¢æ»å¨
        if (e.cancelable) {
          e.preventDefault();
        }
      } else {
        return;
      }
      //å¦ææ»å¨å°åºé¨äºï¼æ»å¨è·ç¦»éçæå¨çè·ç¦»å¢å ç¼æ¢å¢å 
      distanceY = -(distanceY / (distanceY - this.damping)) * this.damping;
      if (Math.abs(distanceY) > this.distanceToRefresh) {
        this.state.currentState = 'activate';
        if (this._ngModelOnChange) {
          this._ngModelOnChange(this.state);
        }
      }
      this.style = {
        '-webkit-transform': 'translate3d( 0, ' + distanceY + 'px, 0 )',
        transform: 'translate3d( 0, ' + distanceY + 'px, 0 )'
      };
    }
  }
  @HostListener('touchend', ['$event'])
  touchend(e) {
    if (!this.startY || this.state.drag === false) {
      return;
    }
    const distanceY = e.changedTouches[0].clientY - this.startY;
    if (Math.abs(distanceY) >= this.distanceToRefresh) {
      this.state.currentState = 'release';
      if (this._direction === 'down' || (this._direction === '' && !this._endRreach)) {
        this.translateY(this.distanceToRefresh + 1);
      } else {
        this.translateY(-this.distanceToRefresh - 1);
      }
      if (this._ngModelOnChange) {
        this._ngModelOnChange(this.state);
      }
      setTimeout(() => {
        this.state.currentState = 'finish';
        if (this._ngModelOnChange) {
          this._ngModelOnChange(this.state);
        }
        if (this._direction === 'down' || (this._direction === '' && !this._endRreach)) {
          this.onRefresh.emit('down');
        } else {
          this.translateY(-this.distanceToRefresh - 1);
          this.onRefresh.emit('up');
        }
        setTimeout(() => {
          this.state.currentState = 'deactivate';
          if (this._ngModelOnChange) {
            this._ngModelOnChange(this.state);
          }
          this.translateY(0);
        }, 0);
      }, 500);
    } else {
      this.translateY(0);
    }
  }
  @HostListener('touchcancel', ['$event'])
  touchcancel(evt) {
    this.translateY(0);
  }
  @HostListener('scroll', ['$event'])
  scroll(evt) {
    this._endTime = Date.now();
    const contentOffset = evt.target.scrollTop;
    const offset = contentOffset - this._lastcontentOffset;
    this._lastcontentOffset = contentOffset;
    if (this._direction === '') {
      if (
        offset > 0 &&
        contentOffset > 0 &&
        evt.target.scrollTop + this.ele.nativeElement.clientHeight === evt.target.scrollHeight
      ) {
        setTimeout(() => {
          this._endRreach = true;
        }, 500);
      } else {
        this._endRreach = false;
      }
    }
    if (!this.endReachedRefresh) {
      return;
    }
    if (
      this._direction === 'down' &&
      offset > 0 &&
      contentOffset > 0 &&
      evt.target.scrollTop + this.ele.nativeElement.clientHeight > evt.target.scrollHeight - this.distanceToRefresh &&
      this._endTime - this._startTime >= 100
    ) {
      this._startTime = this._endTime;
      if (this.refreshing) {
        this.state.currentState = 'release';
        if (this._ngModelOnChange) {
          this._ngModelOnChange(this.state);
        }
      }
      setTimeout(() => {
        if (this._direction === '') {
          this._endRreach = true;
        }
        if (this.endReachedRefresh) {
          this.onRefresh.emit('endReachedRefresh');
        }
        if (this.refreshing) {
          this.state.currentState = 'finish';
          if (this._ngModelOnChange) {
            this._ngModelOnChange(this.state);
          }
        }
      }, 500);
    } else {
      setTimeout(() => {
        if (this._direction === '') {
          this._endRreach = false;
        }
        if (this.refreshing) {
          this.state.currentState = 'finish';
          if (this._ngModelOnChange) {
            this._ngModelOnChange(this.state);
          }
        }
      }, 500);
    }
  }

  constructor(private ele: ElementRef) {}

  isTemplateRef(value) {
    if (value) {
      return value instanceof TemplateRef;
    }
  }

  translateY(distanceY) {
    this.transtionCls = 'am-pull-to-refresh-transition';
    this.style = {
      '-webkit-transform': 'translate3d( 0, ' + distanceY + 'px, 0 )',
      transform: 'translate3d( 0, ' + distanceY + 'px, 0 )'
    };
  }

  writeValue(value: object): void {
    if (value !== null) {
      this.state = value;
    }
  }

  registerOnChange(fn: (_: object) => {}): void {
    this._ngModelOnChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this._ngModelOnTouched = fn;
  }
}
